export default __webpack_public_path__ + "static/media/Explore UI with React.07cee130.jpg";